/**
 * Abnahme 0.58 F07: Bildschirmtastatur. Der Fokuszoom ist über die Schriftgröße gelöst (index.css); hier geht es um
 * die durch die Tastatur verkleinerte sichtbare Fläche: Hat ein Feld in einem Fenster den Fokus und verdeckt die
 * Tastatur es, wird der nächste scrollbare Vorfahre so weit verschoben, dass Feld und Cursor sichtbar bleiben.
 * Grundlage ist `visualViewport` (Höhe und Versatz) – `100dvh` allein reicht nicht in allen Browsern.
 */
const editable = (el: Element | null): el is HTMLElement =>
  !!el && (el instanceof HTMLTextAreaElement || el instanceof HTMLSelectElement || (el instanceof HTMLInputElement && !['checkbox', 'radio', 'button', 'submit', 'range', 'color', 'file'].includes(el.type)) || (el as HTMLElement).isContentEditable);

function scroller(el: HTMLElement): HTMLElement | null {
  for (let p = el.parentElement; p; p = p.parentElement) {
    const o = getComputedStyle(p).overflowY;
    if ((o === 'auto' || o === 'scroll') && p.scrollHeight > p.clientHeight) return p;
  }
  return null;
}

/** Feld in die sichtbare Fläche holen (nur Touch, nur wenn verdeckt) */
export function fitFocused(target: EventTarget | null) {
  const vv = typeof window !== 'undefined' ? window.visualViewport : null;
  if (!vv || !matchMedia('(pointer: coarse)').matches || !editable(target as Element)) return;
  const el = target as HTMLElement;
  const fit = () => {
    if (document.activeElement !== el) return;
    const r = el.getBoundingClientRect();
    const bottom = vv.offsetTop + vv.height - 12;
    const top = vv.offsetTop + 12;
    const box = scroller(el);
    if (!box) return;
    if (r.bottom > bottom) box.scrollTop += Math.min(r.bottom - bottom, r.top - top);
    else if (r.top < top) box.scrollTop -= top - r.top;
  };
  // Tastatur fährt animiert ein: nach der Größenänderung und zur Sicherheit nach kurzer Zeit prüfen
  vv.addEventListener('resize', fit, { once: true });
  window.setTimeout(fit, 350);
}
